import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";

import Home from './Pages/Home';
import About from './Pages/About';
import Header from './Component/Header';


import Footter from './Component/Footter';


// import Checkpage from './Pages/vaccine/Checkpage';
// import Stuallpage from './Pages/vaccine/Stuallpage';
// import Tmm from './Pages/vaccine/Tmm';
// import Personnelpage from './Pages/vaccine/Personnelpage';
// import Report from './Pages/vaccine/Report';
import Homepage from './Pages/Homepage';
import Registerstudent from './Pages/register/Registerstudent';
import Registerauthorities from './Pages/register/Registerauthorities';
import Homepage2 from './Pages/Homepage2';
import Homepage3 from './Pages/Homepage3';





export default class Routes extends Component {
    render() {
        return (
            <>
    
    
   
            <Router basename="/" >
                <Header />
                <br/>
                <div className="content-container"> 
               <Switch>
                  
            
                    <Route exact path="/" component={Homepage3} />
                    {/* <Route exact path="/login" component={Home} /> */}
                    {/* <Route exact path="/Timetable" component={Timetable} />
                    <Route exact path="/Listname" component={Listname} />
                    <Route exact path="/Listname2" component={Listname2} />
                    <Route exact path="/Classroom" component={Classroom} />
                    <Route exact path="/Teach" component={Teach} />
                    <Route exact path="/Learn" component={Learn} />
                    <Route exact path="/Check/:idemp" component={Checkpage} />
                    <Route exact path="/Stuall" component={Stuallpage} />
                    <Route exact path="/Tmm" component={Tmm} />
                    <Route exact path="/Personnelpage" component={Personnelpage} />
                    <Route exact path="/Report" component={Report} />
                    <Route exact path="/Registerstudent" component={Registerstudent} />
                    <Route exact path="/Registerauthorities" component={Registerauthorities} /> */}
                    

               
                    <Route render={function () {return <h1>Not Found</h1> }} />
                </Switch> <br/>
</div>
               <footer className="footer--pin">
  <Footter />
</footer>
               
            </Router>
            
        
          </>  
        )
    }
}
